<div class="modal fade close-mod" id="login-form" role="dialog">
    <div class="modal-dialog modal-dialog-centered ">
        <div class="modal-content">
            <!-- <div class="modal-header">
                <a href="#" class="close" data-dismiss="modal" aria-label="close" (click)="backToLoginPage()">&times;</a>
            </div> -->

            <div class="modal-body">
                <a href="#" class="close" data-dismiss="modal" aria-label="close" (click)="backToLoginPage()">&times;</a>

                <div class="contactus-details-right logfrm">
                    <div class="log-form" *ngIf="state=='login'">
                        <div class="log-logo">
                            <img src="" alt="">
                        </div>
                        <!--log-logo-->
                        <h3 class="login-title">Welcome Back!</h3>
                        <div class="log-ff">
                            <!-- <p><input type="text" name="" class="form-control" placeholder="email"></p>
                    <p><input type="password" name="" class="form-control" placeholder="password"></p> -->
                            <form autocomplete="nope" #userForm="ngForm" (ngSubmit)="doLogin(userForm.value)" novalidate="">
                                <div class="form-group">
                                    <label class="login-label" for="input-email">Email</label>

                                    <div class="input-group">
                                        <span class="input-group-text login-addons" id="email-addon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-envelope-open" viewBox="0 0 16 16">
                                          <path d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.818l5.724 3.465L8 8.917l1.276.766L15 6.218V5.4a1 1 0 0 0-.53-.882l-6-3.2zM15 7.388l-4.754 2.877L15 13.117v-5.73zm-.035 6.874L8 10.083l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738zM1 13.117l4.754-2.852L1 7.387v5.73zM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2z"/>
                                        </svg>
                                      </span>
                                        <input required id="email" pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$" name="email" class="form-control email-input" [(ngModel)]="login.email" #fullemail="ngModel"
                                            placeholder="Enter your registered email" aria-describedby="email-addon" />
                                    </div>

                                    <div class="form-text error" *ngIf="fullemail.touched && fullemail.errors?.rwarningequired">
                                        Email is required!
                                    </div>
                                    <div class="form-text error" *ngIf="fullemail.touched && fullemail.errors?.pattern ">
                                        Email is invalid!
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="login-label" for="input-password">Password</label>

                                    <div class="input-group">
                                        <span class="input-group-text login-addons" id="pass-addon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-lock" viewBox="0 0 16 16">
                                          <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
                                        </svg>
                                      </span>
                                        <input required id="password" type="password" name="password" class="form-control pass-input" [(ngModel)]="lo && !success_sentgin.password" #fullpassword="ngModel" placeholder="Enter your password" aria-describedby="pass-addon" />
                                    </div>

                                    <div class="form-text error" *ngIf="fullpassword.touched && fullpassword.errors?.required">
                                        Password is required
                                    </div>
                                    <div class="form-text error" *ngIf="isError">
                                        <ng-container *ngIf="showMaxRetriesError; else otherError">
                                            {{ showMaxRetriesError }}
                                        </ng-container>
                                        <ng-template #otherError>
                                            Couldn't find your account or you typed a wrong password. Please contact us if you are having issues logging in.
                                        </ng-template>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <!-- <div class="col-sm-12 col-md-7">
                                        <div class="forg"><a class="ffo" (click)="forgetPassword()">forgot password?</a></div>
                                    </div> -->
                                    <ng-container *ngIf="!login_spinner; else logging_in">
                                        <button class="btn button brand-button login-but" disabled="" type="submit" [disabled]="userForm.invalid"> Log In </button>
                                        
                                    </ng-container>
                                    
                                    <ng-template #logging_in>
                                        <button class="btn button brand-button login-but" type="submit" [disabled]="true"><i class="fas fa-spinner fa-spin"></i> Logging In </button>
                                    </ng-template>

                                </div>
                            </form>
                            <!-- <button class="login-with-google-btn" (click)="loginGoogle()">Sign in with Google</button> -->

                            <button class="gsi-material-button" (click)="loginGoogle()" style="width:100">
                                <div class="gsi-material-button-state"></div>
                                <div class="gsi-material-button-content-wrapper">
                                    <div class="gsi-material-button-icon">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                                        <path fill="none" d="M0 0h48v48H0z"></path>
                                    </svg>
                                    </div>
                                    <span class="gsi-material-button-contents">Sign in with Google</span>
                                    <span style="display: none;">Sign in with Google</span>
                                </div>
                            </button>
                            <!--login-with-google-btn-->
                        </div>

                    </div>
                    <!--log-frm-->


                    <div class="reset-pas" *ngIf="state=='forget-password'">
                        <div class="log-frm2">
                            <div class="log-logo">
                                <!-- <img src="../../assets/images/thedocweb-logo-normal.svg" alt=""> -->
                            </div>
                            <!--log-logo-->

                            <div class="say-hello">
                                an email will be sent with the reset link
                            </div>
                            <!--say-hello-->

                            <form #forgetPassForm="ngForm" (ngSubmit)="passwordChange(forgetPassForm)">
                                <div class="form-group">
                                    <label class="sr-only" for="input-email">email address</label>
                                    <input required id="email" pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$" name="email" class="form-control" [(ngModel)]="login.email" #fullemail="ngModel"
                                        placeholder="Enter your registered email id" />
                                    <div class="form-text error" *ngIf="fullemail.touched && fullemail.errors?.required">
                                        email id is required!
                                    </div>
                                    <div class="form-text error" *ngIf="fullemail.touched && fullemail.errors?.pattern ">
                                        email Id is invalid!
                                    </div>

                                    <!-- {{isResetError}} {{resetMessage}} -->
                                    <div class="form-text error" *ngIf="isResetError && resetMessage">
                                        {{resetMessage}}
                                    </div>
                                    <div class="form-text success" *ngIf="!isResetError && resetMessage">
                                        {{resetMessage}}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 col-md-7">
                                        <div class="forg"><a class="bac" (click)="backToLoginPage()">back</a></div>
                                    </div>

                                    <div class="col-sm-12 col-md-5">
                                        <button class="forg-riht sub-btn1" [disabled]="forgetPassForm.invalid" type="submit"><i *ngIf="login_spinner" class="fas fa-spinner animate-spinner"></i> Request </button>
                                        <!-- <div class="forg-riht"><input type="submit" value="request" [disabled]="forgetPassForm.invalid"class="sub-btn1" name=""></div> -->
                                    </div>
                                </div>
                            </form>

                        </div>
                        <!--log-frm-->
                    </div>
                    <div class="log-form" *ngIf="state=='otp-verification'">
                        <h3 class="login-title">Verify OTP</h3>
                        <p class="text-center">An OTP has been sent to <strong>{{ login.email }}</strong>. Please enter it below to
                            continue.</p>
                    
                        <form #otpForm="ngForm" (ngSubmit)="verifyOtp(otpForm.value)">
                            <div class="form-group text-center">
                                <input type="text" id="otp" name="otp" class="form-control text-center w-50 mx-auto" [(ngModel)]="login.otp" (ngModelChange)="isOtpError=false"
                                    #otp="ngModel" required maxlength="6" placeholder="Enter 6-digit code" />
                    
                                <div class="form-text error" *ngIf="otp.touched && otp.errors?.required">
                                    Please enter the OTP to proceed.
                                </div>
                                <div class="form-text error" *ngIf="isOtpError">
                                    The code you entered is incorrect or expired. Try again.
                                </div>
                            </div>
                    
                            <div class="form-group text-center mt-4">
                                <button class="btn button brand-button login-but" type="submit" [disabled]="otpForm.invalid">
                                    Continue
                                </button>
                            </div>
                            
                            <div class="form-group text-center mt-3 ">
                                <small class="text-muted">
                                    Didn't receive an OTP?
                                    <button type="button" class="btn btn-link p-0 align-baseline" [disabled]="resendDisabled" (click)="resendOtp()">
                                        <span *ngIf="resendDisabled">Resend available in {{ resendTimer }}s</span>
                                        <span *ngIf="!resendDisabled">Resend OTP</span>
                                    </button>
                                </small>
                                <div class="form-text error" *ngIf="showMaxRetriesError">
                                    {{ showMaxRetriesError }}
                                </div>
                            </div>
                        </form>
                    </div>

                    <!--reset-pas-->
                </div>
                <!-- contactus-details-right -->
            </div>
        </div>
    </div>
</div>